import { useEffect } from 'react';
import CollectionPage from './CollectionPage';

export default function Accessories() {
  useEffect(() => { document.title = 'Motors, Swivels & Accessories | SpinWorld.Us'; }, []);
  return (
    <CollectionPage
      category="ACCESSORIES"
      title="Keep it Spinning"
      subtitle="Motors, swivels, and tails"
      heroImage=""
      heroGradient
      description="Everything you need to install, maintain, and enhance your wind spinner collection. From solar and battery motors for calm days to swivels, tails, and hanging hooks — these accessories keep the art in motion all year round."
    />
  );
}